export { default as ResultsPagination } from './ResultsPagination';
